export enum GenericEvents {
	ClickBreadcrumb = 'click_breadcrumb',
	PdpAction = 'pdp_action',
	ClickSize = 'click_size',
	ShowDisclaimerSize = 'show_disclaimer_size',
	VideoView = 'video_view',
	VideoError = 'video_error',
	VideoAutoPlay = 'video_auto_play',
	VideoAutoPause = 'video_auto_pause',
	VideoPlayClick = 'video_play_click',
	VideoPauseClick = 'video_pause_click',
	VideoEnded = 'video_ended',
	ClickShopTheLook = 'click_shop_the_look',
	ViewProductQualities = 'view_product_qualities',
}
